<template>
  <table class="checkout-products">
    <tr :key="item.name" v-for="item in this.products" class="position-relative">
      <td class="thumbnail border rounded-3 bg-light"><img :src="item.image" />
      <span class="position-absolute top-0 start-5 translate-middle badge rounded-pill bg-secondary">
          {{item.quantity}}
        </span>
      </td>
      <td class="product-name">
        {{ item.name }}<br />
      </td>
      <td class="price">
        <span v-if="item.originalPrice != item.price" class="discounted-price">
          {{currencySymbol}}{{ (item.quantity * item.originalPrice / 100).toFixed(2) }}<br />
        </span>
        <span>{{currencySymbol}}{{ (item.quantity * item.price / 100).toFixed(2) }}</span>
      </td>
    </tr>
    <tr v-if="plan.originalPrice > 0" class="position-relative">
      <td class="thumbnail border rounded-3 bg-light"><img :src="plan.image" />
      <span class="position-absolute top-0 start-5 translate-middle badge rounded-pill bg-secondary" style="height: 19px;">
          {{plan.quantity}}
        </span></td>
      <td class="product-name">
        {{ plan.name }}
      </td>
      <td class="price">
        <span v-if="plan.originalPrice != plan.price" class="discounted-price">
          {{currencySymbol}}{{ (plan.quantity * plan.originalPrice / 100).toFixed(2) }}<br />
        </span>
        <span>{{currencySymbol}}{{ (plan.quantity * plan.price / 100).toFixed(2) }}</span>
      </td>
    </tr>
  </table>
</template>
<script>
export default {
  name: 'CheckoutProducts',
  props: ['plan', 'products', 'currencySymbol']
};
</script>
